import { AxiosResponse } from "axios";
import request from "../axios-instance";
import { TreeViewResponse } from "./types";
import { GetMappingGuideResponse } from "../table/types";

const getTreeViewUsedInRole = async (
  workbookId: string,
  roleKey: string,
  tableId: string,
) => {
  const response = await request.get(
    `/v1/workbooks/${workbookId}/taxonomy/roles/${roleKey}/used-tags/tree-view`,
    {
      params: {
        tableId,
      },
    },
  );

  return response.data as TreeViewResponse;
};

export const getMappingGuideWithMappedTags = async (
  workbookId: string,
  roleId: string,
  focusTagKey: string,
) => {
  const response: AxiosResponse<GetMappingGuideResponse> = await request.get(
    `/v1/workbooks/${workbookId}/roles/${roleId}/mapping-guide?focusTagKey=${focusTagKey}`,
  );

  return response.data;
};

export default getTreeViewUsedInRole;
